/**
 * @Author : ZhuYongFang
 * @Date : 2019/6/10
 * @Version : 1.0
 * @Content : 接口请求头的签名生成
 */
import { Base64 } from 'js-base64'
import sha256 from 'js-sha256'

export function createSignature (contentType, params, timestamp, secretKey = 'isearch') {
  // 1. 先对请求参数进行排序，再构造签名源串
  const sourceStr = paramsStrSort(contentType, params, timestamp)
  // console.log('源串：', sourceStr)
  // 2. 将源串进行URL编码，并对部分字符进行转换
  let escape = encodeURIComponent(sourceStr)
  // console.log(escape)
  escape = escape.replace(/\+/g, '%20').replace(/\*/g, '%2A').replace(/~/g, '%7E').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29')
  // console.log('源串encodeURIComponent编码：', escape)
  // 3. 使用sha256加密算法，使用secret对步骤2中得到的源串加密，secret暂时使用isearch
  const encryptionSign = sha256.hmac(secretKey, escape)
  // console.log('sha256加密：', encryptionSign)
  // 4. 将加密后的字符串进行Base64编码,得到的最后的签名值
  const sign = Base64.encode(encryptionSign).replace(/\r\n/g, '')
  // console.log('去除Base64编码后的换行符', sign)
  // 5. 去掉Base64编码后的字符串中的换行符(\r\n)
  return sign
}

/**
 * 对请求参数进行排序，
 * 构造签名源串
 * @param {*} params 接口请求参数
 */
function paramsStrSort (contentType, params, timestamp) {
  // console.log(contentType)
  // console.log(typeof params)
  let paramsStr = ''
  if (typeof params === 'string') {
    paramsStr = params
  } else if (typeof params === 'object') {
    // 主要判断post请求方式下，参数类型是否是json或者formData格式，给予不同的操作
    // application/json 对应的操作
    if (contentType && contentType.indexOf('application/json') !== -1) {
      paramsStr = JSON.stringify(params)
      // 非文件FormData格式参数
      if (Object.prototype.toString.call(params) === '[object Object]') {
        // 若为空对象，则置空源串初始值
        if (paramsStr === '{}') {
          paramsStr = ''
        }
      }
      // 文件流 formData 格式参数
      if (Object.prototype.toString.call(params) === '[object FormData]') {
        // 重新初始化源串原始值
        paramsStr = ''
        // for (var item of params) {
        //   // 索引0为参数 key 值
        //   // console.log(item[0])
        //   // 索引1为参数 value 值，判断该值是否是File类型，若是则跳过，不加入源串
        //   // console.log(item[1] instanceof File)
        //   if (item[1] instanceof File) {
        //     continue
        //   } else {
        //     paramsStr += `${item[0]}=${item[1]}`
        //   }
        // }
      }
    } else { // 非 application/json 对应的操作
      var arr = []
      for (var i in params) {
        arr.push((i + '=' + params[i]))
      }
      paramsStr = arr.join('&')
    }
  } else if (typeof params === 'undefined') {
    paramsStr = ''
  }
  var urlStr = ''
  var newUrl = ''
  // 判断有无params
  if (paramsStr) {
    urlStr = paramsStr.split('&').sort().join('&')
    newUrl = urlStr + '&timestamp=' + timestamp
  } else {
    newUrl = 'timestamp=' + timestamp
  }
  return newUrl
}
